/**
 * InputReason
 */

import { FieldLabel } from 'src/presentations/components/molecules/fields/FieldLabel';
import { FC } from 'react';
import { useFieldMaterialUIStyles } from 'src/presentations/components/molecules/fields/useFieldMaterialUIStyles';
import { FieldValues } from 'react-hook-form';
import { SelectElement, SelectElementProps } from 'react-hook-form-mui';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useDefaultProps } from '../useDefaultProps';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MuiFormLabel-root': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
}));

// Style for menu paper and items
const menuProps = {
  PaperProps: {
    sx: {
      '& .MuiMenuItem-root': {
        fontSize: '16px',
        '@media (max-width: 1520px)': {
          fontSize: '14px',
        },
      },
    },
  },
};

interface IRhfMuiSelectProps extends SelectElementProps<FieldValues> {
  hideFieldLabel?: boolean;
  multiple?: boolean;
}

export const RhfMuiSelect: FC<IRhfMuiSelectProps> = (props) => {
  const {
    fullWidth = true,
    size = 'small',
    options,
    label,
    placeholder,
    children,
    SelectProps,
    hideFieldLabel,
    isReadOnly,
    multiple,
    ...rest
  } = { ...props, ...useDefaultProps(props) };
  const { classes, cx } = useFieldMaterialUIStyles();

  const selectOptions = placeholder
    ? [
        {
          id: '',
          label: placeholder,
          disabled: true,
        },
        ...options,
      ]
    : options;

  return (
    <FieldLabel label={!hideFieldLabel && label}>
      <StyledBox className='relative'>
        <SelectElement
          className={cx({ [classes.shortWidth]: !fullWidth }, classes.inputField)}
          fullWidth
          size={size}
          options={selectOptions}
          label={!placeholder && label}
          SelectProps={{
            displayEmpty: !!placeholder,
            multiple,
            MenuProps: {
              ...menuProps,
              ...(SelectProps?.MenuProps || {}),
            },
            ...SelectProps,
          }}
          {...rest}
        />
        {children}
      </StyledBox>
    </FieldLabel>
  );
};
